<footer class="sigma_footer style-3 sigma_footer-dark pb-0">
    <div class="sigma_footer-middle">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="sigma_footer-logo mb-4 text-center text-sm-left">
                        <img src="assets/img/logo-2.png" alt="logo">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="sigma_footer-widget">
                        <p class="mb-4">Adventure Store Hiking and Camping Theme<br> Welcome to the Campa Camping Website</p>
                        <ul class="sigma_sm square justify-content-center justify-content-sm-start">
                            <li>
                                <a href="#"><i class="fab fa-facebook-f"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="fab fa-twitter"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="fab fa-instagram"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                    <div class="sigma_footer-widget">
                        <ul class="sigma_footer-links">
                            <li>
                                <a routerLink="/services">Services</a>
                            </li>
                            <li>
                                <a routerLink="/case-studies">Portfolio</a>
                            </li>
                            <li>
                                <a routerLink="/shop">Ecommerce</a>
                            </li>
                            <li>
                                <a routerLink="/team">Team</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                    <div class="sigma_footer-widget">
                        <ul class="sigma_footer-links">
                            <li>
                                <a routerLink="/">Home</a>
                            </li>
                            <li>
                                <a routerLink="/about">About</a>
                            </li>
                            <li>
                                <a routerLink="/blog-grid">Blog</a>
                            </li>
                            <li>
                                <a routerLink="/contact">Contacts</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                    <div class="sigma_footer-widget">
                        <ul class="sigma_footer-links">
                            <li>
                                <a routerLink="/contact">Help</a>
                            </li>
                            <li>
                                <a routerLink="/faqs">Faq</a>
                            </li>
                            <li>
                                <a routerLink="/pricing">Pricing</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="sigma_footer-bottom">
            <div class="sigma_footer-copyright m-0">
                <p class="mb-0"> &copy; Website -
                    <a href="#">2021</a>
                </p>
            </div>
        </div>
    </div>
</footer>